import { MARQUEE_ITEMS } from "@/data/content";

export const Marquee = () => {
  const row = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
  return (
    <div
      data-testid="editorial-marquee"
      className="relative overflow-hidden bg-navy py-5"
      aria-hidden="true"
    >
      <div className="flex w-max animate-marquee items-center whitespace-nowrap">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span className="font-display text-lg font-semibold uppercase tracking-widest text-white/90 md:text-xl">
                  {item}
                </span>
                <span className="mx-8 inline-block h-1.5 w-1.5 rotate-45 bg-white/40" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
